import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReviewAverageComponent from '../global/review-average-component';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { getListingImage, getNumberWithCommas } from '../../constants/util';

const moment = extendMoment(Moment);

class SearchListComponent extends Component {
  constructor(props) {
    super(props);
  }

  handleEnter(id) {
    this.props.mouseEnter(id);
  }

  handleLeave() {
    this.props.mouseLeave();
  }

  calculateAvgPrice = (pricingObj) => {
    var avgPrice = pricingObj.baseFee;
    let from = this.props.dates.from;
    let to = this.props.dates.to;
    if (from && to) {
      let nights = moment(to).diff(from, "days");
      let dates = Array.from(
        moment.range(moment(from), moment(to)).by("day")
      ).slice(0, nights);
      let overrideDates = pricingObj.overrides;
      let overlapPrices = [];
      for (let i = 0; i < dates.length; ++i) {
        let override = overrideDates.filter((o) =>
          dates[i].isSame(moment(o.date), "day")
        )[0];
        if (override) {
          overlapPrices.push(override.price);
        }
      }
      let overridePriceSum = overlapPrices.reduce((sum, p) => sum + p, 0);
      let totalPrice =
        overridePriceSum + (nights - overlapPrices.length) * pricingObj.baseFee;
      avgPrice = Math.round(totalPrice / nights);
    }

    return avgPrice;
  };


  render() {
    return (
      <div className="result-card-main">
        {this.props.listings &&
          this.props.listings.map((l, i) => {
            let url = `/listing/${l._id}`;
            url =
              this.props.dates.from && this.props.dates.to
                ? url +
                  `?start=${new Date(
                    this.props.dates.from
                  ).toISOString()}&end=${new Date(
                    this.props.dates.to
                  ).toISOString()}`
                : url;
            const { dates } = this.props;
            const { pricing, averageAmount } = l;
            const average = dates.from && dates.to && averageAmount ? averageAmount : (pricing.average || pricing.baseFee);
            const formattedPrice = `$${getNumberWithCommas(Math.round(average))}`;
            return (
              <div
                className="listing-card"
                key={i}
                onMouseEnter={() => this.handleEnter(l._id)}
                onMouseLeave={() => this.handleLeave()}
              >
                <Link to={url}>
                  <div className="row">
                    {l.photos.length > 0 && (
                      <div className="col image-container">
                        <div
                          style={{
                            backgroundImage: `url(${getListingImage(l)})`,
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="row image-overlap">
                    <div className="col">
                      <span className="price-bold">{formattedPrice} </span>
                      avg/night
                      {/* <span className="price-bold">${this.calculateAvgPrice(l.pricing)}</span> avg/night */}
                    </div>
                  </div>
                  <div className="row">
                    <span className="col-md-7 marker pr-0">
                      <i className="fas fa-map-marker-alt"></i> {l.address.city}
                      , {l.address.state}
                    </span>
                    <div className="col-md-5 pl-md-0">
                      <div className="text-md-right">
                        <ReviewAverageComponent
                          reviews={l.reviews}
                          averageRating={l.averageRating}
                          starsOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col listing-name">{l.listingName}</div>
                  </div>
                  <div className="row">
                    <div className="col listing-details">
                      <span className="details">{l.houseType}</span> |{" "}
                      {l.bedrooms}{" "}
                      {l.bedrooms.count > 1 ? "bedrooms" : "bedroom"}
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    );
  }
}

export default SearchListComponent;
